import CashboxApproval from "./CashboxApproval";
import { connect } from "react-redux";

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps)(CashboxApproval);
